import React from "react";
import Icon from "../../../components/AppIcon";

const ReportIndicator = ({ reportReady, status }) => {
  if (reportReady && status?.toLowerCase() === "completed") {
    return (
      <div className="flex items-center gap-1.5 mt-1.5 bg-green-50 px-2 py-1 rounded-md border border-green-100">
        <div className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse"></div>
        <Icon name="FileText" size={10} className="text-green-600" />
        <span className="text-[10px] font-medium text-green-700">Report Ready</span>
      </div>
    );
  }
  return null;
};

export default ReportIndicator;